import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';

import { CarteraServiceProvider } from '../../providers/cartera-service/cartera-service';

import {BusquedaPage} from '../../pages/busqueda/busqueda'

/**
 * Generated class for the MedidaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-medida',
  templateUrl: 'medida.html',
})



export class MedidaPage {

	objmedida:any;  
	loading: any;
	detalleBusqueda: any;

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams
  	, public servicio:CarteraServiceProvider
  	, public loadingCtrl: LoadingController
  	, public modalCtrl: ModalController
  	) {
  	this.objmedida={ id:0, idempresa:1, descripcion:'', idestado:0, cantidad:1 };
  }

  ionViewDidLoad() {
  }
  botonNuevo(){
  	this.objmedida.id=0;
  	this.objmedida.descripcion='';
  	this.objmedida.cantidad=1;
  }
  botonGrabar(){
  	this.servicio.postMedida(this.objmedida).then((result) => 
  	{
  		console.log(result);
  		this.showLoader('Se guardó correctamente!!',1000);
  		this.botonNuevo();
  		
 	 },
 	  (err) => {
    	console.log(err);
    	alert(err);
  	 });
  }
  botonBuscar(){
  	this.servicio.getMedida().then((result) => {
  		//console.log(result);
  		this.detalleBusqueda={'parametro':result, 'campobus':'descripcion'};
  		let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda);
  		myModal.onDidDismiss(data => {
    		if (data != null) this.objmedida=data;
  		});
    	myModal.present();
  	},
  	(err) => {
  		console.log(err);
  	});

  	
  }
   showLoader(mensaje,tiempo){
 
        this.loading = this.loadingCtrl.create({
            content: mensaje,
            duration: tiempo,
            spinner: 'hide'
        });
 
        this.loading.present();

       this.loading.onDidDismiss(() => {
          
        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/medida/medida.ts